import React, { useEffect, useMemo, useState } from 'react'
import { Col, Form, Row, Spinner } from 'react-bootstrap'
import { FaChevronLeft, FaSave } from 'react-icons/fa'
import { AsyncPaginate } from 'react-select-async-paginate'
import MasterService from '../../../../../services/master/MasterService'
import UserService from '../../../../../services/user/UserService'
import PbUmkuService from '../../../../../services/pbumku/PbumkuService'
import KapalService from '../../../../../services/kapal/KapalService'
import SweetAlert from 'react-bootstrap-sweetalert'
import { romanNum } from '../../../../../utilities/Utils'

const ViewKapalHeader = ({ dataHeader, cancelHeader, saveHeader }) => {
    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()

    let masterService = useMemo(() => new MasterService(), [])
    let userService = useMemo(() => new UserService(), [])
    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    let kapalService = useMemo(() => new KapalService(), [])

    useEffect(() => {
        if (!dataHeader) return
        const fetchAllData = async () => {
            try {
                if (dataHeader.idKapal !== undefined) {
                    const optJenisPermohonan = [{ value: '1', label: 'Baru' }, { value: '2', label: 'Perpanjangan' }]
                    setValueJenisPermohonanOpt(optJenisPermohonan.find(opt => opt.value === dataHeader.statusPermohonan))

                    setValueNib(dataHeader.nib)

                    const resMasterKapal = await kapalService.getMasterKapalById(dataHeader.idKapal)
                    let masterKapal = resMasterKapal.data
                    setValueNamaKapal(masterKapal.namaKapal)
                    setValueUkuranKapal(masterKapal.ukuranKapal)
                    setValueNpwp(masterKapal.npwp)
                    setValuePemilik(masterKapal.pemilik)
                    setValueAlamat(masterKapal.alamatPemilik)
                    setValueTelepon(masterKapal.telpPemilik)
                    setValueEmail(masterKapal.emailPemilik)
                    setValuePenanggungJawab(masterKapal.penanggungJawab)
                    setValueAlamatPj(masterKapal.alamatPj)
                    setValueTelpPj(masterKapal.telpPj)
                    setValueEmailPj(masterKapal.emailPj)
                    setValueNamaNahkoda(dataHeader.namaNahkoda)
                    setValueJumlahAbk(dataHeader.jumlahAbk)

                    const resProp = await masterService.getPropinsiById(dataHeader.kdProp)
                    setValueSearchPropOpt(resProp.data)

                    const resKota = await masterService.getKotaById(dataHeader.kdKota)
                    setValueSearchKotaOpt(resKota.data)

                    const resUpt = await userService.getUptById(dataHeader.kodeUpt)
                    setValueUrUpt(resUpt.data.nmPendek)
                    setValueKdUptKota(resUpt.data.kdUnit)

                    const optJenisKapal = [{ value: '1', label: 'Penangkap' }, { value: '2', label: 'Pengangkut' }]
                    setValueJenisKapalOpt(optJenisKapal.find(opt => opt.value === dataHeader.jenisKapal))

                    const optFasilitas = [{ value: '1', label: 'Dengan alat pembeku (freezer fishing vessel)' }, { value: '2', label: 'Tanpa alat pembeku (non freezer fishing vessel)' }]
                    setValueFasilitasPembekuanOpt(optFasilitas.find(opt => opt.value === dataHeader.fasilitasPembeku))
                }
            } catch (error) {
                // console.log(error)
            }
        }
        fetchAllData()
    }, [dataHeader, kapalService, masterService, userService])

    const [valueJenisPermohonanOpt, setValueJenisPermohonanOpt] = useState(null)
    async function loadOptionJenisPermohonan(search, loadedOption, { page }) {
        const options = [
            {
                value: '1',
                label: 'Baru'
            },
            {
                value: '2',
                label: 'Perpanjangan'
            }
        ]
        return {
            options: options,
        }
    }
    const onChangeJenisPermohonanOpt = e => {
        setValueJenisPermohonanOpt(e)
    }

    const [valueJenisKapalOpt, setValueJenisKapalOpt] = useState(null)
    async function loadOptionJenisKapal(search, loadedOption, { page }) {
        const options = [
            {
                value: '1',
                label: 'Penangkap'
            },
            {
                value: '2',
                label: 'Pengangkut'
            }
        ]
        return {
            options: options
        }
    }
    const onChangeJenisKapalOpt = e => {
        setValueJenisKapalOpt(e)
    }

    const [valueFasilitasPembekuanOpt, setValueFasilitasPembekuanOpt] = useState(null)
    async function loadOptionFasilitas(search, loadedOption, { page }) {
        const options = [
            {
                value: '1',
                label: 'Dengan alat pembeku (freezer fishing vessel)'
            },
            {
                value: '2',
                label: 'Tanpa alat pembeku (non freezer fishing vessel)'
            }
        ]
        return {
            options: options
        }
    }
    const onChangeFasilitasOpt = e => {
        setValueFasilitasPembekuanOpt(e)
    }

    const [keyForSecondSelect, setKeyForSecondSelect] = useState(0)
    const [valueSearchPropOpt, setValueSearchPropOpt] = useState(null)
    const loadOptionPropinsi = async (search, loadedOption, { page = 1 }) => {
        const response = await masterService.listPropinsi(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangePropOpt = e => {
        setValueSearchPropOpt(e)
        setKeyForSecondSelect(prevKey => prevKey + 1)
    }
    const [valueSearchKotaOpt, setValueSearchKotaOpt] = useState(null)
    const loadOptionKota = async (search, loadedOption, { page = 1 }) => {
        const response = await masterService.listKota(valueSearchPropOpt.kodePropinsi, search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangeKotaOpt = e => {
        // console.log(e)
        setValueSearchKotaOpt(e)
        setValueKdUptKota(e.kodeUpt)
        getNamaUnit(e.kodeUpt)
    }
    const [valueKdUptKota, setValueKdUptKota] = useState(null)
    const [valueUrUpt, setValueUrUpt] = useState(null)
    const getNamaUnit = async (kode) => {
        try {
            // console.log(kode)
            const response = await userService.getUptById(kode)
            setValueUrUpt(response.data.nmPendek)
        } catch (error) {
            setValueUrUpt(null)
            console.log(error)
        }
    }

    const [valueNib, setValueNib] = useState(null)
    const onChangeNib = e => {
        setValueNib(e.target.value)
    }
    const [valueNamaKapal, setValueNamaKapal] = useState(null)
    const onChangeNamaKapal = e => {
        setValueNamaKapal(e.target.value)
    }
    const [valueUkuranKapal, setValueUkuranKapal] = useState(null)
    const onChangeUkuranKapal = e => {
        setValueUkuranKapal(e.target.value)
    }
    const [valueNamaNahkoda, setValueNamaNahkoda] = useState(null)
    const onChangeNamaNahkoda = e => {
        setValueNamaNahkoda(e.target.value)
    }
    const [valueJumlahAbk, setValueJumlahAbk] = useState(null)
    const onChangeJumlahAbk = e => {
        setValueJumlahAbk(e.target.value)
    }

    const [valueNpwp, setValueNpwp] = useState(null)
    const onChangeNpwp = e => {
        setValueNpwp(e.target.value)
    }
    const [valuePemilik, setValuePemilik] = useState(null)
    const onChangePemilik = e => {
        setValuePemilik(e.target.value)
    }
    const [valueAlamat, setValueAlamat] = useState(null)
    const onChangeAlamat = e => {
        setValueAlamat(e.target.value)
    }
    const [valueTelepon, setValueTelepon] = useState(null)
    const onChangeTelepon = e => {
        setValueTelepon(e.target.value)
    }
    const [valueEmail, setValueEmail] = useState(null)
    const onChangeEmail = e => {
        setValueEmail(e.target.value)
    }

    const [valuePenanggungJawab, setValuePenanggungJawab] = useState(null)
    const onChangePenanggungJawab = e => {
        setValuePenanggungJawab(e.target.value)
    }
    const [valueAlamatPj, setValueAlamatPj] = useState(null)
    const onChangeAlamatPj = e => {
        setValueAlamatPj(e.target.value)
    }
    const [valueTelpPj, setValueTelpPj] = useState(null)
    const onChangeTelpPj = e => {
        setValueTelpPj(e.target.value)
    }
    const [valueEmailPj, setValueEmailPj] = useState(null)
    const onChangeEmailPj = e => {
        setValueEmailPj(e.target.value)
    }

    const [loadingSave, setLoadingSave] = useState(false)
    const [showConfirmSave, setShowConfirmSave] = useState(false)
    const handleCloseConfirmSave = () => setShowConfirmSave(false)
    const handleShowConfirmSave = () => {
        setShowConfirmSave(true)
    }
    const [showSaveSuccess, setShowSaveSucces] = useState(false)
    const [showSaveFailed, setShowSaveFailed] = useState(false)
    const [message, setMessage] = useState(null)

    const handleClickSimpan = async () => {
        setLoadingSave(true)
        try {
            let nomorAju
            let tanggalAju
            let idKapal
            let masterKapal
            if (dataHeader === undefined || dataHeader === null || Object.keys(dataHeader).length === 0) {
                const respNomor = await pbumkuService.ambilNomorService('PPM_KAPAL', valueKdUptKota, currentYear, localStorage.getItem('username'))
                nomorAju = respNomor.data.uraianPusat + respNomor.data.kodePusat + romanNum(currentMonth) + currentYear + respNomor.data.nomorUrut
                tanggalAju = new Date()
                idKapal = 0
            } else {
                nomorAju = dataHeader.nomorAjuKapal
                tanggalAju = dataHeader.tanggalAjuKapal
                idKapal = dataHeader.idKapal
                const resMasterKapal = await kapalService.getMasterKapalById(idKapal)
                masterKapal = resMasterKapal.data
            }

            let jsonMasterKapal = {
                ...masterKapal,
                namaKapal: valueNamaKapal,
                ukuranKapal: valueUkuranKapal,
                nib: valueNib,
                npwp: valueNpwp,
                pemilik: valuePemilik,
                alamatPemilik: valueAlamat,
                telpPemilik: valueTelepon,
                emailPemilik: valueEmail,
                penanggungJawab: valuePenanggungJawab,
                alamatPj: valueAlamatPj,
                telpPj: valueTelpPj,
                emailPj: valueEmailPj,
                namaNahkoda: valueNamaNahkoda,
                jumlahAbk: valueJumlahAbk,
                kodeTrader: localStorage.getItem("kodeTrader") ? localStorage.getItem("kodeTrader") : null,
            }

            if (idKapal !== 0) {
                jsonMasterKapal = {
                    ...jsonMasterKapal,
                    idKapal: idKapal,
                    updatedBy: localStorage.getItem("userId"),
                    updatedDate: new Date()
                }
            } else {
                jsonMasterKapal = {
                    ...jsonMasterKapal,
                    createdBy: localStorage.getItem("userId"),
                    createdDate: new Date()
                }
            }

            const resMaster = await kapalService.saveMasterKapal(jsonMasterKapal)
            if (resMaster.data.kode === '200') {
                let jsonPpmKapal = {
                    ...dataHeader,
                    nomorAjuKapal: nomorAju,
                    tanggalAjuKapal: tanggalAju,
                    idKapal: resMaster.data.id,
                    namaKapal: valueNamaKapal,
                    ukuranKapal: valueUkuranKapal,
                    statusPermohonan: valueJenisPermohonanOpt.value,
                    namaNahkoda: valueNamaNahkoda,
                    jumlahAbk: valueJumlahAbk,
                    kdProp: valueSearchPropOpt.kodePropinsi,
                    kdKota: valueSearchKotaOpt.kodeKota,
                    kodeUpt: valueKdUptKota,
                    jenisKapal: valueJenisKapalOpt.value,
                    fasilitasPembeku: valueFasilitasPembekuanOpt.value,
                    kodeStatus: '000',
                    nib: valueNib,
                    kodeTrader: localStorage.getItem("kodeTrader") ? localStorage.getItem("kodeTrader") : null,
                    createdBy: localStorage.getItem("userId"),
                    createdDate: new Date()
                }
                const resPpmKapal = await kapalService.saveKapalHeader(jsonPpmKapal)
                if (resPpmKapal.data.kode === '200') {
                    let jsonStatus = {
                        nomorAjuKapal: nomorAju,
                        kodeStatus: '000',
                        waktuStatus: new Date(),
                        createdBy: localStorage.getItem("userId"),
                        createdAt: new Date()
                    }
                    await kapalService.saveKapalStatus(jsonStatus)
                    setShowSaveSucces(true)
                    setShowConfirmSave(false)
                } else {
                    setShowConfirmSave(false)
                    setShowSaveFailed(true)
                    setMessage("Gagal Simpan PPM Kapal")
                }
            } else {
                setShowConfirmSave(false)
                setShowSaveFailed(true)
                setMessage("Gagal Simpan Master Kapal")
            }
        } catch (error) {
            console.log(error)
            setShowConfirmSave(false)
            setShowSaveFailed(true)
            // setMessage(error.response.data)
        }
        setLoadingSave(false)
    }

    const handleClickSaveSuccess = () => {
        setLoadingSave(false)
        setShowSaveSucces(false)
        saveHeader('dokumen')
    }

    const handleClickSaveFailed = () => {
        setLoadingSave(false)
        setShowSaveFailed(false)
    }

    return (
        <>
            <div className="form-card text-start">
                <div className="row mb-3">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Data Pengajuan : {localStorage.getItem('nomorAjuKapalStorage')} </h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Jenis Permohonan <span className='text-danger'>*</span></Form.Label>
                                        <Col sm="8">
                                            <AsyncPaginate
                                                loadOptions={loadOptionJenisPermohonan}
                                                value={valueJenisPermohonanOpt}
                                                getOptionValue={(option) => option.value}
                                                getOptionLabel={(option) => option.label}
                                                additional={{
                                                    page: 0,
                                                }}
                                                onChange={onChangeJenisPermohonanOpt}
                                                isDisabled={localStorage.getItem('isEditKapal') === '0' ? true : false}
                                            />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Data Kapal</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">NIB<span className='text-danger'>*</span></Form.Label>
                                        <Col sm="9">
                                            <Form.Control type="text" placeholder="NIB" className="form-control-sm" value={valueNib} onChange={onChangeNib} disabled={localStorage.getItem('isEditKapal') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Kapal <span className='text-danger'>*</span></Form.Label>
                                        <Col sm="9">
                                            <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={valueNamaKapal} onChange={onChangeNamaKapal} disabled={localStorage.getItem('isEditKapal') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Ukuran Kapal (GT) <span className='text-danger'>*</span></Form.Label>
                                        <Col sm="2">
                                            <Form.Control type="text" placeholder="Ukuran" className="form-control-sm" value={valueUkuranKapal} onChange={onChangeUkuranKapal} disabled={localStorage.getItem('isEditKapal') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Jenis Kapal <span className='text-danger'>*</span></Form.Label>
                                        <Col sm="4">
                                            <AsyncPaginate
                                                loadOptions={loadOptionJenisKapal}
                                                value={valueJenisKapalOpt}
                                                getOptionValue={(option) => option.value}
                                                getOptionLabel={(option) => option.label}
                                                additional={{
                                                    page: 0,
                                                }}
                                                onChange={onChangeJenisKapalOpt}
                                                isDisabled={localStorage.getItem('isEditKapal') === '0' ? true : false}
                                            />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Fasilitas Kapal <span className='text-danger'>*</span></Form.Label>
                                        <Col sm="9">
                                            <AsyncPaginate
                                                loadOptions={loadOptionFasilitas}
                                                value={valueFasilitasPembekuanOpt}
                                                getOptionValue={(option) => option.value}
                                                getOptionLabel={(option) => option.label}
                                                additional={{
                                                    page: 0,
                                                }}
                                                onChange={onChangeFasilitasOpt}
                                                isDisabled={localStorage.getItem('isEditKapal') === '0' ? true : false}
                                            />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Nahkoda <span className='text-danger'>*</span></Form.Label>
                                        <Col sm="9">
                                            <Form.Control type="text" placeholder="Nama Nahkoda" className="form-control-sm" value={valueNamaNahkoda} onChange={onChangeNamaNahkoda} disabled={localStorage.getItem('isEditKapal') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Jumlah ABK <span className='text-danger'>*</span></Form.Label>
                                        <Col sm="2">
                                            <Form.Control type="text" placeholder="Jumlah" className="form-control-sm" value={valueJumlahAbk} onChange={onChangeJumlahAbk} disabled={localStorage.getItem('isEditKapal') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Data Pemilik</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">NPWP <span className='text-danger'>*</span></Form.Label>
                                        <Col sm="9">
                                            <Form.Control type="text" placeholder="NPWP" className="form-control-sm" value={valueNpwp} onChange={onChangeNpwp} disabled={localStorage.getItem('isEditKapal') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Pemilik <span className='text-danger'>*</span></Form.Label>
                                        <Col sm="9">
                                            <Form.Control type="text" placeholder="Nama Pemilik" className="form-control-sm" value={valuePemilik} onChange={onChangePemilik} disabled={localStorage.getItem('isEditKapal') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Alamat <span className='text-danger'>*</span></Form.Label>
                                        <Col sm="9">
                                            <Form.Control as="textarea" placeholder="Alamat" className="form-control-sm" value={valueAlamat} onChange={onChangeAlamat} disabled={localStorage.getItem('isEditKapal') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Telpon Pemilik <span className='text-danger'>*</span></Form.Label>
                                        <Col sm="6">
                                            <Form.Control type="text" placeholder="Telepon Pemilik" className="form-control-sm" value={valueTelepon} onChange={onChangeTelepon} disabled={localStorage.getItem('isEditKapal') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Email Pemilik <span className='text-danger'>*</span></Form.Label>
                                        <Col sm="6">
                                            <Form.Control type="email" placeholder="Email Pemilik" className="form-control-sm" value={valueEmail} onChange={onChangeEmail} disabled={localStorage.getItem('isEditKapal') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Propinsi <span className='text-danger'>*</span></Form.Label>
                                        <Col sm="8">
                                            <AsyncPaginate
                                                loadOptions={loadOptionPropinsi}
                                                value={valueSearchPropOpt}
                                                getOptionLabel={(option) => option.uraianPropinsi}
                                                getOptionValue={(option) => option.kodePropinsi}
                                                additional={{
                                                    page: 1
                                                }}
                                                onChange={onChangePropOpt}
                                                isDisabled={localStorage.getItem('isEditKapal') === '0' ? true : false}
                                            />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Kota <span className='text-danger'>*</span></Form.Label>
                                        <Col sm="8">
                                            <AsyncPaginate
                                                key={keyForSecondSelect}
                                                loadOptions={loadOptionKota}
                                                value={valueSearchKotaOpt}
                                                getOptionLabel={(option) => option.uraianKota}
                                                getOptionValue={(option) => option.kodeKota}
                                                additional={{
                                                    page: 1
                                                }}
                                                onChange={onChangeKotaOpt}
                                                isDisabled={localStorage.getItem('isEditKapal') === '0' ? true : false}
                                            />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">UPT</Form.Label>
                                        <Col sm="8">
                                            <Form.Control type="text" placeholder="UPT" className="form-control-sm" value={valueUrUpt} disabled />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-7">
                                <h6 className="mb-4">Data Penanggung Jawab</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama PJ <span className='text-danger'>*</span></Form.Label>
                                        <Col sm="9">
                                            <Form.Control type="text" placeholder="Nama Penanggung Jawab" className="form-control-sm" value={valuePenanggungJawab} onChange={onChangePenanggungJawab} disabled={localStorage.getItem('isEditKapal') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Alamat PJ<span className='text-danger'>*</span></Form.Label>
                                        <Col sm="9">
                                            <Form.Control as="textarea" placeholder="Alamat Penanggung Jawab" className="form-control-sm" value={valueAlamatPj} onChange={onChangeAlamatPj} disabled={localStorage.getItem('isEditKapal') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Telpon PJ <span className='text-danger'>*</span></Form.Label>
                                        <Col sm="6">
                                            <Form.Control type="text" placeholder="Telepon Penanggung Jawab" className="form-control-sm" value={valueTelpPj} onChange={onChangeTelpPj} disabled={localStorage.getItem('isEditKapal') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Email PJ <span className='text-danger'>*</span></Form.Label>
                                        <Col sm="6">
                                            <Form.Control type="email" placeholder="Email Penanggung Jawab" className="form-control-sm" value={valueEmailPj} onChange={onChangeEmailPj} disabled={localStorage.getItem('isEditKapal') === '0' ? true : false} />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>

                {
                    localStorage.getItem('isEditKapal') === '1' ? <>
                        <button type="button" name="next" className="btn btn-primary next action-button float-end btn-sm" value="Next" onClick={handleShowConfirmSave}><FaSave /> Simpan & Lanjutkan</button>
                        <button type="button" name="back" className="btn btn-dark previous action-button-previous float-end me-1 btn-sm" value="Kembali" onClick={() => cancelHeader()} ><FaChevronLeft /> Batal</button>
                    </> :
                        <button type="button" name="back" className="btn btn-dark previous action-button-previous float-end me-1 btn-sm" value="Kembali" onClick={() => cancelHeader()} ><FaChevronLeft /> Kembali</button>
                }
            </div>
            {
                showConfirmSave &&
                <SweetAlert
                    title="Simpan Data Entitas?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Simpan"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSimpan}
                    onCancel={handleCloseConfirmSave}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSaveSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data Entitas Berhasil"
                    onConfirm={handleClickSaveSuccess}
                    btnSize="sm"
                />
            }
            {
                showSaveFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Entitas Gagal"
                    onConfirm={handleClickSaveFailed}
                    btnSize="sm"
                    timeout={2000}
                >{message}</SweetAlert>
            }
        </>
    )
}

export default ViewKapalHeader